import React from 'react';
import { Edit, SimpleForm } from 'react-admin';
import { Alert } from '@mui/material';
import Permission from '../../components/Permission';
import RequiredChain from '../../components/RequiredChain';
import { PERMISSIONS } from '../../constants';
import WhatsappNumberForm from './WhatsappNumberForm';
import ConfirmSaveToolbar from './ConfirmSaveToolbar';

const EditWhatsappNumber = (props) => (
  <Permission permission={PERMISSIONS.MANAGE_WHATSAPP_NUMBERS}>
    <RequiredChain>
      <Edit {...props} title="Editar número de WhatsApp" mutationMode="pessimistic">
        <SimpleForm sx={{ maxWidth: 620 }} toolbar={<ConfirmSaveToolbar />}>
          <Alert severity="info" sx={{ mb: 2 }}>
            Para tirar o acesso de alguém, use o botão Excluir na lista.
            O cadastro fica no histórico e o número volta a ficar livre.
          </Alert>
          <WhatsappNumberForm />
        </SimpleForm>
      </Edit>
    </RequiredChain>
  </Permission>
);

export default EditWhatsappNumber;
